import api, { handleError, handleResponse } from '../';

export const getOperator = (handle: string) => {
    return api
        .get('operator', { params: { handle } })
        .then((response) => handleResponse(response))
        .catch((error) => handleError(error));
};

export const trackEvent = (name: string, site: string) => {
    return api
        .get('event', { params: {
            name,
            site,
            distinct_id: "unused" } }
        )
        .then((response) => handleResponse(response))
        .catch((error) => handleError(error));
};
